import { createAction, props } from '@ngrx/store';
import { AssetSubscriptionV26 } from 'src/app/models-v26/asset-subscription-v26';
import { DeliveryItemV26 } from 'src/app/models-v26/deliveryitem-v26';
import { AddAssetOrderRequestV26 } from 'src/app/models-v26/wizards/add-asset-order-request-v26';
import { ActionResponse } from 'src/app/models/action-response';
import { Desk } from 'src/app/models/desk';
import { ReactivateAssetAdditionalInfoV26 } from 'src/app/shared-components-v26/allocation-wizard-modal-dialogs/reactivate-asset-wizard/additional-step/additional-info';
import { ReactivateAssetInitStepV26 } from 'src/app/shared-components-v26/allocation-wizard-modal-dialogs/reactivate-asset-wizard/init-step/init-step';
import { ReactivateAssetDueDatesV26 } from 'src/app/shared-components-v26/allocation-wizard-modal-dialogs/reactivate-asset-wizard/init-step/reactivate-asset-due-date-info';

export const selectInitStep = createAction(
  '[V26 Asset Grid] Select Reactivate Init Information Step',
  props<{ initStep: ReactivateAssetInitStepV26 }>(),
);

export const selectAssetServicesInit = createAction(
  '[V26 Reactivate Asset Init Step] Select Asset Services Init Information Step',
  props<{ initAssetServiceStep: AssetSubscriptionV26[] }>(),
);

export const selectDueDatesStep = createAction(
  '[V26 Reactivate Asset Due Date Step] Select Due Date Step',
  props<{ dueDatesStep: ReactivateAssetDueDatesV26 }>(),
);

export const selectDeskStep = createAction('[V26 Reactivate Asset Desk Step] Select Desk Step', props<{ deskStep: Desk }>());

export const selectProductStep = createAction(
  '[V26 Reactivate Asset Product Step] Select Product Step',
  props<{ productStep: DeliveryItemV26 }>(),
);

export const selectServiceStep = createAction(
  '[V26 Reactivate Asset Service Step] Select Service Information Step',
  props<{ serviceStep: DeliveryItemV26[] }>(),
);

export const deleteServiceStep = createAction('[Reactivate Asset Service Step] Delete Service Information Step');

export const selectAdditionalStep = createAction(
  '[V26 Reactivate Asset AddInfo Step] Select Additional Information Step',
  props<{ addInfoStep: ReactivateAssetAdditionalInfoV26 }>(),
);

export const deleteAdditionalStep = createAction('[V26 Reactivate Asset AddInfo Step] Delete Additional Information Step');

export const exitReactivateAssetWizard = createAction('[V26 Reactivate Asset Wizard Page] Exit Allocation Reactivate Asset Wizard');

export const destroyWizard = createAction('[V26 Reactivate Asset Wizard Page] Destroy Wizard');

export const createNewReactivateAsset = createAction(
  '[V26 Reactivate Asset Confirmation Step] Reactivate Asset Information Step',
  props<{ newOrder: AddAssetOrderRequestV26 }>(),
);

export const createNewOrderSuccess = createAction(
  '[V26 Reactivate Asset Confirmation Step] Reactivate Asset Information Step Success',
  props<{ response: ActionResponse }>(),
);

export const createNewOrderFail = createAction(
  '[V26 Reactivate Asset Confirmation Step] Reactivate Asset Information Step Fail',
  props<{ errorMessage: string }>(),
);
